import { Injectable } from '@angular/core';
import {
  ISpacedRepetitionCard,
  ISpacedRepetitionReview,
  SpacedRepetition,
} from '@flasd/spaced-repetition';
import { Flashcard } from '../models/flashcard.model';
import { Difficulty, Review } from '../models/review.model';

class SpacedRepetitionCard implements ISpacedRepetitionCard {
  id: string;
  originalFlashcard: Flashcard;

  constructor(id: string, originalFlashcard: Flashcard) {
    this.id = id;
    this.originalFlashcard = originalFlashcard;
  }
}

@Injectable({
  providedIn: 'root',
})
export class SpacedRepetitionService {
  private spacedRepetition: SpacedRepetition;

  constructor() {
    this.spacedRepetition = new SpacedRepetition({
      debug: true,
      nowFn: () => Date.now(),
    });
  }

  getDueFlashcards(flashcards: Flashcard[], reviews: Review[]): Flashcard[] {
    const spacedRepetitionCards = flashcards.map(
      this.flashcardToISpacedRepetitionCard
    );
    const sortedReviews = reviews.sort((a, b) => {
      return a.timestamp!.toDate().getTime() - b.timestamp!.toDate().getTime();
    });

    const spacedRepetitionReviews = sortedReviews.map(
      this.reviewToISpacedRepetitionReview
    );
    const dueCards = this.spacedRepetition.getDueCards(
      spacedRepetitionCards,
      spacedRepetitionReviews
    );
    return dueCards.map(([card]) => {
      return (<SpacedRepetitionCard>card).originalFlashcard;
    });
  }

  private flashcardToISpacedRepetitionCard(
    flashcard: Flashcard
  ): ISpacedRepetitionCard {
    return new SpacedRepetitionCard(flashcard.id!, flashcard);
  }

  private reviewToISpacedRepetitionReview(
    review: Review
  ): ISpacedRepetitionReview {
    return {
      card: review.flashCardId!,
      difficulty: review.difficulty || Difficulty.HARD,
      timestamp: review.timestamp!.toDate().getTime(),
    };
  }
}
